import React from 'react'

import PropTypes from 'prop-types'
import * as S from './styles'

const ErrorMessage = ({ children, ...rest }) => {
  return (
    <>
      {Array.isArray(children) ? (
        children.map((errorMessage, index) => (
          <S.ErrorMessage
            key={index}
            type="text"
            color="#d33e3e"
            fontStyle="italic"
            {...rest}
          >
            {errorMessage}
          </S.ErrorMessage>
        ))
      ) : (
        <S.ErrorMessage
          type="text"
          color="#d33e3e"
          fontStyle="italic"
          {...rest}
        >
          {children}
        </S.ErrorMessage>
      )}
    </>
  )
}

ErrorMessage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.array,
    PropTypes.bool
  ]).isRequired,
  width: PropTypes.string
}

export default ErrorMessage
